import { ITraySolution, ITraySolutionInstance } from '@/types/integrations.types';
import { PayloadAction } from '@reduxjs/toolkit';
import { ChannelSettingsReducerCreator } from '../types';

const setInboundIntegrationToEditReducer = (create: ChannelSettingsReducerCreator) => {
  return create.reducer(
    (state, action: PayloadAction<{ solution: ITraySolution; instance: ITraySolutionInstance } | null>) => {
      state.inboundIntegrationToEdit = action.payload;
    }
  );
};

export default setInboundIntegrationToEditReducer;
